export const contentPasteGo = {
  icon: 'content_paste_go',
  text: 'Режим вставки активен - нажмите Ctrl+V для загрузки файлов'
};

export const contentPaste = {
  icon: 'content_paste',
  text: 'Нажмите, чтобы включить вставку файлов через Ctrl+V'
};
